import { useMemo } from 'react'
import { collection, query, where } from 'firebase/firestore'
import { db } from '@/lib/firebase'
import { COLLECTIONS, type Code } from '@shared/model'
import { useAuth } from '@/lib/auth'
import { useQuerySnapshot } from './useQuerySnapshot'

export interface MyCodesResult {
  codes: Code[]
  /** Koderna grupperade per period – ett konto kan äga flera häften. */
  codesByBooklet: Record<string, Code[]>
  loading: boolean
  error: Error | null
}

/** Alla häften kontot äger, oavsett period. */
export function useMyCodes(): MyCodesResult {
  const { user } = useAuth()

  const codesQuery = useMemo(() => {
    if (!user) return null
    return query(collection(db, COLLECTIONS.codes), where('ownerUid', '==', user.uid))
  }, [user])

  const { data, loading, error } = useQuerySnapshot<Code>(codesQuery)

  const codesByBooklet = useMemo(() => {
    const grouped: Record<string, Code[]> = {}
    for (const code of data) {
      ;(grouped[code.bookletId] ??= []).push(code)
    }
    return grouped
  }, [data])

  return { codes: data, codesByBooklet, loading, error }
}
